import { InputAdornment } from '@material-ui/core'
import { AttachMoney } from '@material-ui/icons'
import { MONEDA } from 'Constants'
import moment from 'moment'

export const ReciboFields = (data, handleChange, edit, permissions) => {
  return [
    {
      label: 'ID recibo',
      class: 'textfield',
      value: data.id,
      sm: 1,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Nº comprobante',
      class: 'textfield',
      value: data.comprobante,
      sm: 2,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Fecha creación',
      class: 'textfield',
      value: data.fecha ? moment(data.fecha).format('DD/MM/YYYY') : '',
      sm: 2,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Usuario',
      class: 'textfield',
      value: data.usuario,
      sm: 3,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Observación',
      class: 'textfield',
      name: 'observacion',
      value: data.observacion,
      sm: 4,
      xs: 12,
      disabled: !data.comprobante || permissions.allowEditMin ? true : !edit,
      onChange: (e) => {
        handleChange('observacion', e.target.value)
      },
    },
  ]
}

export const DataExtra = (data) => {
  const formatSaldo = (value) => {
    return parseFloat(value).toString()
  }

  return [
    {
      label: 'Saldo restante recibo',
      class: 'textfield',
      value: data?.saldoResto ? formatSaldo(data.saldoResto.toFixed(1)) : 0,
      sm: 8,
      xs: 12,
      disabled: true,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
    {
      label: 'Total recibo',
      class: 'textfield',
      value: data?.total ? formatSaldo(Number(data.total)) : 0,
      sm: 8,
      xs: 12,
      disabled: true,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
  ]
}

export const editFields = (values, handleChange, data) => {
  const tarjetasFiltradas =
    values.tipo === 2
      ? data.tarjetas.filter((tarjeta) => tarjeta.tipo === 1)
      : values.tipo === 3
        ? data.tarjetas.filter((tarjeta) => tarjeta.tipo === 2)
        : []

  const getPaymentMethodId = (tipo) => {
    const metodo = data.metodosPago.find((metodo) => metodo.id === tipo)
    return metodo ? metodo.tipo : null
  }

  const origenLabel = data.tarjetas.find((tarjeta) => tarjeta.id === values.origen)?.nombre || ''

  const idMetodoPago = getPaymentMethodId(values.tipo)

  return values.tipo === 1
    ? [
        {
          label: 'Método de pago',
          name: 'tipo',
          value: idMetodoPago,
          sm: 6,
          xs: 12,
          disabled: true,
          class: 'textfield',
        },
        {
          label: 'Importe en pesos',
          name: 'importe',
          sm: 6,
          xs: 12,
          class: 'textfield',
          type: 'number',
          value: values.importe.replace(/[^0-9.,]+/g, ''),
          inputProps: {
            startAdornment: (
              <InputAdornment position="start">
                <AttachMoney />
              </InputAdornment>
            ),
          },
          onChange: (e) => handleChange('importe', e.target.value),
        },
        {
          label: 'Observación',
          name: 'detalle',
          sm: 12,
          xs: 12,
          class: 'textfield',
          value: values.detalle,
          //disabled: values.tipo !== 4,
          onChange: (e) => handleChange('detalle', e.target.value),
        },
      ]
    : values.tipo === 2 || values.tipo === 3
      ? [
          {
            label: 'Método de pago',
            name: 'tipo',
            value: idMetodoPago,
            sm: 6,
            xs: 12,
            disabled: true,
            class: 'textfield',
          },
          {
            label: 'Tarjeta',
            name: 'origen',
            sm: 6,
            xs: 12,
            class: 'autocomplete',
            disabled: values.tipo === 2 || values.tipo === 3 ? false : true,
            value: values.tipo === 2 || values.tipo === 3 ? origenLabel : null,
            options: tarjetasFiltradas,
            optionLabel: `options["nombre"]`,
            optionValue: 'nombre',
            onChange: (e) => {
              handleChange('origen', e.id)
            },
          },
          {
            label: 'Importe en pesos',
            name: 'importe',
            sm: 6,
            xs: 12,
            class: 'textfield',
            type: 'number',
            value: values.importe.replace(/[^0-9.,]+/g, ''),
            inputProps: {
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoney />
                </InputAdornment>
              ),
            },
            onChange: (e) => handleChange('importe', e.target.value),
          },
          {
            label: 'Observación',
            name: 'detalle',
            sm: 6,
            xs: 12,
            class: 'textfield',
            value: values.detalle,
            //disabled: values.tipo !== 4,
            onChange: (e) => handleChange('detalle', e.target.value),
          },
          {
            label: 'Lote',
            name: 'lote',
            sm: 6,
            xs: 12,
            class: 'textfield',
            type: 'number',
            disabled: values.tipo === 2 || values.tipo === 3 ? false : true,
            value: Math.max(0, parseInt(values.lote)),
            onChange: (e) => handleChange('lote', e.target.value),
          },
          {
            label: 'Cupón',
            name: 'cupon',
            sm: 6,
            xs: 12,
            class: 'textfield',
            type: 'number',
            disabled: values.tipo === 2 || values.tipo === 3 ? false : true,
            value:
              values.tipo === 2 || values.tipo === 3 ? Math.max(0, parseInt(values.cupon)) : null,
            onChange: (e) => handleChange('cupon', e.target.value),
          },
        ]
      : values.tipo === 4
        ? [
            {
              label: 'Método de pago',
              name: 'tipo',
              value: idMetodoPago,
              sm: 6,
              xs: 12,
              disabled: true,
              class: 'textfield',
            },
            {
              label: 'Importe en pesos',
              name: 'importe',
              sm: 6,
              xs: 12,
              class: 'textfield',
              type: 'number',
              value: values.importe.replace(/[^0-9.,]+/g, ''),
              inputProps: {
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoney />
                  </InputAdornment>
                ),
              },
              onChange: (e) => handleChange('importe', e.target.value),
            },
            {
              label: 'Nº de operación',
              name: 'cupon',
              sm: 6,
              class: 'textfield',
              type: 'number',
              disabled: ![4, 6, 7].includes(values.tipo),
              value:
                values.tipo === 4 || values.tipo === 6 || values.tipo === 7
                  ? Math.max(0, parseInt(values.cupon))
                  : null,
              onChange: (e) => handleChange('cupon', e.target.value),
            },
            {
              label: 'Observación',
              name: 'detalle',
              sm: 6,
              xs: 12,
              class: 'textfield',
              value: values.detalle,
              //disabled: values.tipo !== 4,
              onChange: (e) => handleChange('detalle', e.target.value),
            },
          ]
        : values.tipo === 10
          ? [
              {
                label: 'Método de pago',
                name: 'tipo',
                value: idMetodoPago,
                sm: 6,
                xs: 12,
                disabled: true,
                class: 'textfield',
              },
              {
                label: 'Importe en pesos',
                name: 'importe',
                sm: 6,
                xs: 12,
                class: 'textfield',
                type: 'number',
                value: values.importe.replace(/[^0-9.,]+/g, ''),
                inputProps: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <AttachMoney />
                    </InputAdornment>
                  ),
                },
                onChange: (e) => handleChange('importe', e.target.value),
              },
              {
                label: 'Nº cheque',
                name: 'cupon',
                sm: 6,
                xs: 12,
                class: 'textfield',
                type: 'number',
                disabled: values.tipo === 5 || values.tipo === 10 ? false : true,
                value:
                  values.tipo === 5 || values.tipo === 10
                    ? Math.max(0, parseInt(values.cupon))
                    : null,
                onChange: (e) => handleChange('cupon', e.target.value),
              },
              {
                label: 'Banco',
                name: 'origen',
                sm: 6,
                xs: 12,
                class: 'autocomplete',
                value:
                  values.tipo === 10 || values.tipo === 6 || values.tipo === 7
                    ? values.origen
                    : null,
                options:
                  values.tipo === 6 || values.tipo === 7
                    ? data.bancos.filter((banco) => banco.propio === 1)
                    : data.bancos.filter((banco) => banco.propio === 0),
                optionLabel: `options["nombre"]`,
                optionValue: 'id',
                disabled: ![10, 6, 7].includes(values.tipo),
                onChange: (e) => {
                  handleChange('origen', e.id)
                },
              },
              {
                label: 'Echeq / ID cheque',
                name: 'barcode',
                sm: 6,
                xs: 12,
                class: 'textfield',
                disabled: values.tipo !== 10,
                value: values.barcode,
                onChange: (e) => handleChange('barcode', e.target.value),
              },
              {
                label: 'Observación',
                name: 'detalle',
                sm: 6,
                xs: 12,
                class: 'textfield',
                value: values.detalle,
                //disabled: values.tipo !== 4,
                onChange: (e) => handleChange('detalle', e.target.value),
              },
            ]
          : values.tipo === 6 || values.tipo === 7
            ? [
                {
                  label: 'Método de pago',
                  name: 'tipo',
                  value: idMetodoPago,
                  sm: 6,
                  xs: 12,
                  disabled: true,
                  class: 'textfield',
                },
                {
                  label: 'Importe en pesos',
                  name: 'importe',
                  sm: 6,
                  xs: 12,
                  class: 'textfield',
                  type: 'number',
                  value: values.importe.replace(/[^0-9.,]+/g, ''),
                  inputProps: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <AttachMoney />
                      </InputAdornment>
                    ),
                  },
                  onChange: (e) => handleChange('importe', e.target.value),
                },
                {
                  label: 'Banco',
                  name: 'origen',
                  sm: 6,
                  xs: 12,
                  class: 'autocomplete',
                  value:
                    values.tipo === 10 || values.tipo === 6 || values.tipo === 7
                      ? values.origen
                      : null,
                  options:
                    values.tipo === 6 || values.tipo === 7
                      ? data.bancos.filter((banco) => banco.propio === 1)
                      : data.bancos.filter((banco) => banco.propio === 0),
                  optionLabel: `options["nombre"]`,
                  optionValue: 'id',
                  disabled: ![10, 6, 7].includes(values.tipo),
                  onChange: (e) => {
                    handleChange('origen', e.id)
                  },
                },
                {
                  label: 'Nº de operación',
                  name: 'cupon',
                  sm: 6,
                  class: 'textfield',
                  type: 'number',
                  disabled: ![4, 6, 7].includes(values.tipo),
                  value:
                    values.tipo === 4 || values.tipo === 6 || values.tipo === 7
                      ? Math.max(0, parseInt(values.cupon))
                      : null,
                  onChange: (e) => handleChange('cupon', e.target.value),
                },
                {
                  label: 'Observación',
                  name: 'detalle',
                  sm: 12,
                  xs: 12,
                  class: 'textfield',
                  value: values.detalle,
                  //disabled: values.tipo !== 4,
                  onChange: (e) => handleChange('detalle', e.target.value),
                },
              ]
            : values.tipo === 8
              ? [
                  {
                    label: 'Método de pago',
                    name: 'tipo',
                    value: idMetodoPago,
                    sm: 6,
                    xs: 12,
                    disabled: true,
                    class: 'textfield',
                  },
                  {
                    label: 'Importe en pesos',
                    name: 'importe',
                    sm: 6,
                    xs: 12,
                    class: 'textfield',
                    type: 'number',
                    value: values.importe.replace(/[^0-9.,]+/g, ''),
                    inputProps: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachMoney />
                        </InputAdornment>
                      ),
                    },
                    onChange: (e) => handleChange('importe', e.target.value),
                  },
                  {
                    label: 'Moneda',
                    name: 'moneda',
                    sm: 6,
                    xs: 12,
                    options: MONEDA,
                    value: values.moneda,
                    optionLabel: `options["label"]`,
                    optionValue: 'label',
                    class: 'autocomplete',
                    disabled: values.tipo !== 8,
                    onChange: (e) => {
                      handleChange('moneda', e.label)
                    },
                  },
                  {
                    label: 'Cotización',
                    name: 'cupon',
                    sm: 6,
                    xs: 12,
                    class: 'textfield',
                    type: 'number',
                    value: values.tipo === 8 ? Math.max(0, parseInt(values.cupon)) : null,
                    disabled: values.tipo !== 8,
                    onChange: (e) => handleChange('cupon', e.target.value),
                  },
                  {
                    label: 'Observación',
                    name: 'detalle',
                    sm: 12,
                    xs: 12,
                    class: 'textfield',
                    value: values.detalle,
                    //disabled: values.tipo !== 4,
                    onChange: (e) => handleChange('detalle', e.target.value),
                  },
                ]
              : values.tipo === 51
                ? [
                    {
                      label: 'Método de pago',
                      name: 'tipo',
                      value: idMetodoPago,
                      sm: 12,
                      xs: 12,
                      disabled: true,
                      class: 'textfield',
                    },
                    {
                      label: 'Retención',
                      name: 'origen',
                      sm: 6,
                      xs: 12,
                      class: 'autocomplete',
                      value:
                        values.tipo === 10 ||
                        values.tipo === 6 ||
                        values.tipo === 7 ||
                        values.tipo === 51
                          ? values.origen
                          : null,
                      options: data.retenciones,
                      optionLabel: `options["nombre"]`,
                      optionValue: 'id',
                      disabled: ![10, 6, 7, 51].includes(values.tipo),
                      onChange: (e) => {
                        handleChange('origen', e.id)
                      },
                    },
                    {
                      label: 'Importe en pesos',
                      name: 'importe',
                      sm: 6,
                      xs: 12,
                      class: 'textfield',
                      type: 'number',
                      value: values.importe.replace(/[^0-9.,]+/g, ''),
                      inputProps: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoney />
                          </InputAdornment>
                        ),
                      },
                      onChange: (e) => handleChange('importe', e.target.value),
                    },
                  ]
                : [
                    {
                      label: 'Método de pago',
                      name: 'tipo',
                      value: idMetodoPago,
                      sm: 8,
                      xs: 12,
                      disabled: true,
                      class: 'textfield',
                    },
                    {
                      label: 'Importe en pesos',
                      name: 'importe',
                      sm: 4,
                      xs: 12,
                      class: 'textfield',
                      type: 'number',
                      value: Math.max(0, parseInt(values.importe)),
                      inputProps: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoney />
                          </InputAdornment>
                        ),
                      },
                      onChange: (e) => handleChange('importe', e.target.value),
                    },
                    {
                      label: 'Nº cheque',
                      name: 'cheque',
                      sm: 12,
                      xs: 12,
                      class: 'textfield',
                      type: 'number',
                      disabled: true,
                      value: values.barcode,
                    },
                  ]
}

export const fieldsAddReceipt = (values, handleChange, isLoading, data) => {
  const tarjetasFiltradas =
    values.tipo === 2
      ? data.tarjetas.filter((tarjeta) => tarjeta.tipo === 1)
      : values.tipo === 3
        ? data.tarjetas.filter(
            (tarjeta) =>
              tarjeta.tipo === 2 && tarjeta.id !== 6 && tarjeta.id !== 7 && tarjeta.id !== 18
          )
        : []

  const handlePaymentMethodChange = (e) => {
    handleChange('tipo', e.id)
    handleChange('origen', null)
    handleChange('importe', '')
    handleChange('descripcion', '')
    handleChange('proveedor', null)
    handleChange('nro_operacion', '')
    handleChange('moneda', null)
    handleChange('cotizacion', '')
    handleChange('lote', '')
    handleChange('cupon', '')
    handleChange('cheque', '')
  }
  const checkCheque = (codigo, verificador) => {
    let ponderador
    if (codigo.length === 10) ponderador = '1397139713'
    if (codigo.length === 8) ponderador = '97139713'
    if (codigo.length === 11) ponderador = '71397139713'

    if (!ponderador) return 'ERROR'

    const cadena = codigo.toString().split('')
    let suma = 0
    cadena.forEach((value, index) => {
      const posicion = parseInt(value) * parseInt(ponderador[index])
      suma += posicion
    })

    let resultado = 10 - suma.toString().split('').pop()
    if (resultado === 10) resultado = 0

    return resultado === verificador ? 'OK' : 'ERROR'
  }
  const calcularNumeroCheque = () => {
    const numeroCheque = (values.linea1 || '') + (values.linea2 || '') + (values.linea3 || '')

    return numeroCheque
  }

  const IMPORTE = {
    label: 'Importe',
    name: 'importe',
    sm: values.tipo === 5 ? 4 : 6,
    xs: 12,
    class: 'textfield',
    type: 'number',
    inputProps: {
      startAdornment: (
        <InputAdornment position="start">
          <AttachMoney />
        </InputAdornment>
      ),
    },
    value: Math.max(0, parseFloat(values.importe)),
    onChange: (e) => handleChange('importe', e.target.value),
  }

  const OBSERVACION = {
    label: 'Observación',
    name: 'detalle',
    sm: [1, 6, 7, 8].includes(values.tipo) ? 6 : 12,
    xs: 12,
    class: 'textfield',
    value: values.detalle,
    onChange: (e) => handleChange('detalle', e.target.value),
  }

  return [
    {
      label: 'Método de pago',
      name: 'tipo',
      options: data?.metodosPago?.filter(
        (metodo) =>
          metodo.id !== 49 &&
          metodo.id !== 50 &&
          metodo.id !== 60 &&
          metodo.id !== 70 &&
          metodo.id !== 9
      ),
      optionLabel: `options["tipo"]`,
      optionValue: 'id',
      value: values.tipo,
      sm: values.tipo === 5 ? 8 : 12,
      xs: 12,
      class: 'autocomplete',
      onChange: handlePaymentMethodChange,
    },
    ...(values.tipo === 1
      ? [IMPORTE, OBSERVACION]
      : values.tipo === 4
        ? [
            IMPORTE,
            {
              label: 'Nº de operación',
              name: 'nro_operacion',
              sm: 6,
              class: 'textfield',
              type: 'number',
              disabled: ![4, 6, 7].includes(values.tipo),
              value: Math.max(0, parseInt(values.nro_operacion)),
              onChange: (e) => handleChange('nro_operacion', e.target.value),
            },
            OBSERVACION,
          ]
        : values.tipo === 2 || values.tipo === 3
          ? [
              {
                label: 'Tarjeta',
                name: `origen_${values.tipo}`,
                sm: 6,
                xs: 12,
                class: 'autocomplete',
                disabled: values.tipo === 2 || values.tipo === 3 ? false : true,
                value: values.origen,
                options: tarjetasFiltradas,
                optionLabel: `options["nombre"]`,
                optionValue: 'id',
                onChange: (e) => {
                  handleChange('origen', e.id)
                },
              },
              IMPORTE,
              {
                label: 'Lote',
                name: 'lote',
                sm: 6,
                xs: 12,
                class: 'textfield',
                type: 'number',
                disabled: values.tipo === 2 || values.tipo === 3 ? false : true,
                value: Math.max(0, parseInt(values.lote)),
                onChange: (e) => handleChange('lote', e.target.value),
              },
              {
                label: 'Cupón',
                name: 'cupon',
                sm: 6,
                xs: 12,
                class: 'textfield',
                type: 'number',
                disabled: values.tipo === 2 || values.tipo === 3 ? false : true,
                value: Math.max(0, parseInt(values.cupon)),
                onChange: (e) => handleChange('cupon', e.target.value),
              },
              OBSERVACION,
            ]
          : values.tipo === 10
            ? [
                {
                  label: 'Nº cheque',
                  name: 'cheque',
                  sm: 6,
                  xs: 12,
                  class: 'textfield',
                  type: 'number',
                  disabled: values.tipo === 5 || values.tipo === 10 ? false : true,
                  value: Math.max(0, parseInt(values.cheque)),
                  onChange: (e) => handleChange('cheque', e.target.value),
                },
                IMPORTE,
                {
                  label: 'Banco',
                  name: `origen_${values.tipo}`,
                  sm: 6,
                  xs: 12,
                  class: 'autocomplete',
                  value: values.proveedor,
                  options:
                    values.tipo === 6 || values.tipo === 7
                      ? data?.bancos?.filter((banco) => banco.propio === 1)
                      : data?.bancos?.filter((banco) => banco.propio === 0),
                  optionLabel: `options["nombre"]`,
                  optionValue: 'id',
                  disabled: ![10, 6, 7].includes(values.tipo),
                  onChange: (e) => {
                    handleChange('origen', e.id)
                  },
                },
                {
                  label: 'Echeq / ID cheque',
                  name: 'barcode',
                  sm: 6,
                  xs: 12,
                  class: 'textfield',
                  disabled: values.tipo !== 10,
                  value: values.barcode,
                  onChange: (e) => handleChange('barcode', e.target.value),
                },
                OBSERVACION,
              ]
            : values.tipo === 6 || values.tipo === 7
              ? [
                  IMPORTE,
                  {
                    label: 'Banco',
                    name: `origen_${values.tipo}`,
                    sm: 6,
                    xs: 12,
                    class: 'autocomplete',
                    value: values.proveedor,
                    options:
                      values.tipo === 6 || values.tipo === 7
                        ? data?.bancos?.filter((banco) => banco.propio === 1)
                        : data?.bancos?.filter((banco) => banco.propio === 0),
                    optionLabel: `options["nombre"]`,
                    optionValue: 'id',
                    disabled: ![10, 6, 7].includes(values.tipo),
                    onChange: (e) => {
                      handleChange('origen', e.id)
                    },
                  },
                  {
                    label: 'Nº de operación',
                    name: 'nro_operacion',
                    sm: 6,
                    class: 'textfield',
                    type: 'number',
                    disabled: ![4, 6, 7].includes(values.tipo),
                    value: Math.max(0, parseInt(values.nro_operacion)),
                    onChange: (e) => handleChange('nro_operacion', e.target.value),
                  },
                  OBSERVACION,
                ]
              : values.tipo === 8
                ? [
                    IMPORTE,
                    {
                      label: 'Moneda',
                      name: `moneda_${values.tipo}`,
                      sm: 6,
                      xs: 12,
                      options: MONEDA,
                      value: values.moneda,
                      optionLabel: `options["label"]`,
                      optionValue: 'id',
                      class: 'autocomplete',
                      disabled: values.tipo !== 8,
                      onChange: (e) => {
                        handleChange('moneda', e.label)
                      },
                    },
                    {
                      label: 'Cotización',
                      name: 'cotizacion',
                      sm: 6,
                      xs: 12,
                      class: 'textfield',
                      type: 'number',
                      value: Math.max(0, parseInt(values.cotizacion)),
                      disabled: values.tipo !== 8,
                      onChange: (e) => handleChange('cotizacion', e.target.value),
                    },
                    OBSERVACION,
                  ]
                : values.tipo === 5
                  ? [
                      IMPORTE,
                      {
                        label: 'Nº cheque',
                        name: 'cheque',
                        sm: 12,
                        xs: 12,
                        class: 'textfield',
                        type: 'number',
                        disabled: true,
                        value: calcularNumeroCheque(),
                      },
                      {
                        label: 'Línea 1',
                        name: 'linea1',
                        sm: 8,
                        xs: 12,
                        class: 'textfield',
                        type: 'number',
                        value: values.linea1 || '',
                        onChange: (e) => {
                          handleChange('linea1', e.target.value)
                          handleChange('cheque', calcularNumeroCheque())
                          handleChange('verificacion1', '')
                          handleChange('linea2', '')
                          handleChange('verificacion2', '')
                          handleChange('linea3', '')
                          handleChange('verificacion3', '')
                        },
                      },
                      {
                        label: 'Verificación 1',
                        name: 'verificacion1',
                        sm: 4,
                        xs: 12,
                        class: 'textfield',
                        type: 'number',
                        value: values.verificacion1 || '',
                        onChange: (e) => {
                          const inputValue = e.target.value

                          handleChange('verificacion1', inputValue)

                          const codigo = values.linea1

                          if (inputValue !== '' && !isNaN(inputValue)) {
                            const verificador = parseInt(inputValue)
                            if (checkCheque(codigo, verificador) === 'OK') {
                              handleChange('linea2Habilitada', true)
                            } else {
                              handleChange('linea2Habilitada', false)
                            }
                          }
                        },
                        disabled: !values.linea1,
                      },
                      {
                        label: 'Línea 2',
                        name: 'linea2',
                        sm: 8,
                        xs: 12,
                        class: 'textfield',
                        type: 'number',
                        value: values.linea2 || '',
                        disabled: !values.linea2Habilitada || !values.verificacion1,
                        onChange: (e) => {
                          handleChange('linea2', e.target.value)
                          handleChange('cheque', calcularNumeroCheque())
                          handleChange('verificacion2', '')
                          handleChange('linea3', '')
                          handleChange('verificacion3', '')
                        },
                      },
                      {
                        label: 'Verificación 2',
                        name: 'verificacion2',
                        sm: 4,
                        xs: 12,
                        class: 'textfield',
                        type: 'number',
                        value: values.verificacion2 || '',
                        disabled: !values.linea2Habilitada || !values.linea2,
                        onChange: (e) => {
                          const inputValue = e.target.value

                          handleChange('verificacion2', inputValue)

                          const codigo = values.linea2

                          if (inputValue !== '' && !isNaN(inputValue)) {
                            const verificador = parseInt(inputValue)
                            if (checkCheque(codigo, verificador) === 'OK') {
                              handleChange('linea3Habilitada', true)
                            } else {
                              handleChange('linea3Habilitada', false)
                            }
                          }
                        },
                      },
                      {
                        label: 'Línea 3',
                        name: 'linea3',
                        sm: 8,
                        xs: 12,
                        class: 'textfield',
                        type: 'number',
                        value: values.linea3 || '',
                        disabled: !values.linea3Habilitada || !values.verificacion2,
                        onChange: (e) => {
                          handleChange('linea3', e.target.value)
                          handleChange('cheque', calcularNumeroCheque())
                          handleChange('verificacion3', '')
                        },
                      },
                      {
                        label: 'Verificación 3',
                        name: 'verificacion3',
                        sm: 4,
                        xs: 12,
                        class: 'textfield',
                        type: 'number',
                        value: values.verificacion3,
                        disabled: !values.linea3Habilitada || !values.linea3,
                        onChange: (e) => {
                          const inputValue = e.target.value

                          handleChange('verificacion3', inputValue)
                          handleChange('cheque', calcularNumeroCheque())

                          const codigo = values.linea3

                          if (inputValue !== '' && !isNaN(inputValue)) {
                            const verificador = parseInt(inputValue)
                            if (checkCheque(codigo, verificador) === 'OK') {
                              handleChange('verificacion', true)
                            } else {
                              handleChange('verificacion', false)
                            }
                          }
                        },
                      },
                    ]
                  : values.tipo === 51
                    ? [
                        {
                          label: 'Retención', // con que nombre mando este dato
                          name: `origen_${values.tipo}`,
                          sm: 6,
                          xs: 12,
                          class: 'autocomplete',
                          disabled: values.tipo !== 51,
                          value: values.origen,
                          options: data?.retenciones,
                          optionLabel: `options["nombre"]`,
                          optionValue: 'id',
                          onChange: (e) => {
                            handleChange('origen', e.id)
                          },
                        },
                        IMPORTE,
                      ]
                    : []),
  ]
}
